import { TOKEN_KEYS } from 'const/settings';
import BaseApi from './BaseApi';
import { getCookie } from 'utils/Cookie';

class AbstractApi extends BaseApi {
  constructor(MAIN_URL) {
    super(MAIN_URL);
    this.AUTH_TOKEN_KEY = 'auth_token_key';
  }

  /** Настройка перед отправкой запроса. Вызывается отдельно для каждого запроса.
   * @param axios Инстанс Axios.
   * @returns Инстанс Axios.
   */
  axiosOverride = (axios) => {
    const accessToken = getCookie(TOKEN_KEYS.AUTH_TOKEN_KEY)
      ? `Bearer ${getCookie(TOKEN_KEYS.AUTH_TOKEN_KEY)}`
      : undefined;
    const headers = axios.defaults.headers.common;

    axios.defaults.withCredentials = true;

    if (accessToken !== undefined && accessToken !== '') {
      headers.Authorization = accessToken;
    } else {
      headers.Authorization = null;
    }

    return axios;
  };
}

export default AbstractApi;
